import React from 'react';
import '../css/App.css';
import ShowcaseHeader from './ShowcaseHeader';
import SectionsPanelRedux from '../containers/sections/SectionsPanel';
import EmbeddedPlayerRedux from '../containers/outputPlayer/EmbeddedPlayer';
import { APP_DESCRIPTION } from '../constants/Labels';
import CompanionRedux from '../containers/companion/Companion';

class App extends React.Component {
  constructor(props) {
    super();
    globalThis.addEventListener('scroll', () => {
      globalThis.lastScrolledValue = globalThis.pageYOffset;
    });
    globalThis.addEventListener('load', () => {
      //try to register plugin with default settings to load omskd libs
      props.registerPlugin();
    });
  }
  render() {
    return (
      <div className="App">
        <div id="productName">Instream Video Showcase</div>
        <ShowcaseHeader description={APP_DESCRIPTION} />
        <SectionsPanelRedux />
        <div className="outputPanel">
          <EmbeddedPlayerRedux />
          <CompanionRedux />
        </div>
      </div>
    );
  }
}

export default App;
